import React from 'react';
import { Button } from '@/components/button/animatedButton';
import DMTooltip from '@/components/tooltip';
import { differenceInMinutes } from 'date-fns';

const EventButton = ({ datetime, link }: { datetime: string; link: string }) => {
  const getButtonState = () => {
    const now = new Date();
    const eventTime = new Date(datetime);
    const minutesDiff = differenceInMinutes(eventTime, now);

    // Scheduled: Until 10 minutes before event time
    if (minutesDiff > 10) {
      return {
        type: 'label',
        text: 'Scheduled',
        className: 'text-orange-500 text-xs font-semibold border border-orange-500 rounded-md p-1',
        toolTip: 'The join button will appear 10 minutes before the scheduled time.',
      };
    }

    // Join Now: From 10 minutes before to 30 minutes after event time
    if (minutesDiff <= 10 && minutesDiff >= -30) {
      return {
        type: 'button',
        text: 'Join Now',
        className: '',
      };
    }

    // Completed: After 30 minutes from event time
    return {
      type: 'label',
      text: 'Completed',
      className: 'text-gray-400 text-xs font-semibold',
      toolTip: 'Session has ended',
    };
  };

  const state = getButtonState();

  if (state.type === 'button') {
    return (
      <Button
        variant='gooeyRight'
        className={`text-xs !px-2 !py-1 border rounded-md bg-transparent text-brand-primary border-brand-primary ${state.className}`}
        onClick={() => window.open(link, '_blank')}
      >
        {state.text}
      </Button>
    );
  }

  return (
    <DMTooltip
      triggerContent={<span className={`${state.className}`}>{state.text}</span>}
      tooltipContent={<p className='text-black text-xs'>{state.toolTip}</p>}
    />
  );
};

export default EventButton;
